import { FC } from 'react';
import { Container } from 'atoms/Container';
import { HeadLine } from 'atoms/Typography/Typography';
import styles from './CategoryHeadline.module.css';

export const CategoryHeadline: FC<{ title?: string }> = ({ title }) =>
  !title ? null : (
    <Container>
      <HeadLine color="purple" tag="h1" type="m" className={styles.headline}>
        {title}
      </HeadLine>
    </Container>
  );
